import { notifyAlert } from '@pricemoov/pollux-react';

import logger from 'services/logger/logger';

export const extractErrorMessage = error => {
    if (error.response && error.response.data && error.response.data.detail) {
        if (Array.isArray(error.response.data.detail)) {
            return error.response.data.detail.join('\n');
        }
        return error.response.data.detail;
    }
    if (error.message) {
        return error.message;
    }
    return error;
};

const notify = error => {
    const message = extractErrorMessage(error);
    logger.error(message);
    notifyAlert({ level: 'error', title: message });
};

export default {
    notify,
};
